import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BackButton } from "components/BackButton";
import { CodesKindToggle } from "components/CodesKindToggle/CodesKindToggle";
import { TabHeader } from "components/TabHeader";
import { useAnalytics } from "contexts/AnalyticsContext";
import { useCodesKind } from "hooks/useCodesKind";
import { routePath } from "shared/constants";
import { BisacCodesContent } from "./BisacCodesContent";
import { BisacCodesHeader } from "./BisacCodesHeader";
import { ThemaCodesContent } from "./ThemaCodesContent";

export const CodesPage = () => {
  const { t } = useTranslation(["general", "themaCodes"]);
  const { gaEvent } = useAnalytics();
  const [hasSwitched, setHasSwitched] = useState(false);
  const { kind, switchKind } = useCodesKind((fromKind, toKind) => {
    gaEvent({
      type: "codes_kind_switched",
      payload: {
        from_kind: fromKind,
        to_kind: toKind,
      },
    });
    setHasSwitched(true);
  });
  const isBisac = kind === "BISAC";
  const kindToggle = (
    <CodesKindToggle
      value={kind}
      onChange={switchKind}
      focusOnMount={hasSwitched}
    />
  );

  return (
    <div className="flex flex-col gap-[37px] h-screen max-h-[calc(100vh-9rem)] overflow-hidden">
      <div>
        <BackButton
          fallbackTo={routePath("/")}
          fallbackLabel={t("general:header.home")}
        />
        {isBisac ? (
          <BisacCodesHeader />
        ) : (
          <TabHeader
            title={t("themaCodes:header.themaCodes")}
            subtitle={t("themaCodes:header.description")}
          />
        )}
      </div>

      <div className="flex flex-col flex-1 gap-2 overflow-hidden min-h-0">
        {isBisac ? (
          <BisacCodesContent kindToggle={kindToggle} />
        ) : (
          <ThemaCodesContent kindToggle={kindToggle} />
        )}
      </div>
    </div>
  );
};
